export enum VehicleAction {
  LEASING = 'leasing',
  WARRANTY = 'warranty',
  TIRE_APPOINTMENT = 'tyreAppointment'
}
